export const manufacturersList = [
  { id: 1, manufacturer: "Тапети" },
  { id: 2, manufacturer: "Текстил" },
  { id: 3, manufacturer: "Завеси" },
  { id: 4, manufacturer: "Пердета" },
  { id: 5, manufacturer: "Мебели" },
  { id: 6, manufacturer: "Осветление" },
  { id: 7, manufacturer: "Килими" },
  { id: 8, manufacturer: "Мокети" },
  { id: 9, manufacturer: "Кожа" },
  { id: 10, manufacturer: "Акустични" },
  { id: 11, manufacturer: "Жилищен интериор" },
  { id: 12, manufacturer: "Хотели" },
  { id: 13, manufacturer: "Ресторанти" },
  { id: 14, manufacturer: "Офиси" },
  { id: 15, manufacturer: "Обществени пространства" },
  { id: 16, manufacturer: "Retail / магазини" },
  { id: 17, manufacturer: "Баня" },
  { id: 18, manufacturer: "Спалня" },
  { id: 19, manufacturer: "Дневна" },
  { id: 20, manufacturer: "Натурални материали" },
  { id: 21, manufacturer: "Лен" },
  { id: 22, manufacturer: "Вълна" },
  { id: 23, manufacturer: "Коприна" },
  { id: 24, manufacturer: "Винил" },
  { id: 25, manufacturer: "Бяло" },
  { id: 26, manufacturer: "Бежово" },
  { id: 27, manufacturer: "Пясъчно" },
  { id: 28, manufacturer: "Сиво" },
  { id: 29, manufacturer: "Черно" },
  { id: 30, manufacturer: "Кафяво" },
  { id: 31, manufacturer: "Зелено" },
  { id: 32, manufacturer: "Маслено зелено" },
  { id: 33, manufacturer: "Синьо" },
  { id: 34, manufacturer: "Тъмносиньо" },
  { id: 35, manufacturer: "Морско синьо" },
  { id: 36, manufacturer: "Бордо" },
  { id: 37, manufacturer: "Червено" },
  { id: 38, manufacturer: "Розово" },
  { id: 39, manufacturer: "Лилаво" },
  { id: 40, manufacturer: "Злато" },
  { id: 41, manufacturer: "Бронз" },
  { id: 42, manufacturer: "Сребро" },

  { id: 43, manufacturer: "Wallcoverings" },
  { id: 44, manufacturer: "Wallpapers" },
  { id: 45, manufacturer: "Textiles" },
  { id: 46, manufacturer: "Curtains" },
  { id: 47, manufacturer: "Furniture" },
  { id: 48, manufacturer: "Lighting" },
  { id: 49, manufacturer: "Rugs" },
  { id: 50, manufacturer: "Carpets" },
  { id: 51, manufacturer: "Leather" },
  { id: 52, manufacturer: "Acoustic panels" },
  { id: 53, manufacturer: "Residential" },
  { id: 54, manufacturer: "Hospitality" },
  { id: 55, manufacturer: "Hotels" },
  { id: 56, manufacturer: "Restaurants" },
  { id: 57, manufacturer: "Offices" },
  { id: 58, manufacturer: "Public spaces" },
  { id: 59, manufacturer: "Retail" },
  { id: 60, manufacturer: "Bathroom" },
  { id: 61, manufacturer: "Bedroom" },
  { id: 62, manufacturer: "Living room" },
  { id: 63, manufacturer: "Natural materials" },
  { id: 64, manufacturer: "Linen" },
  { id: 65, manufacturer: "Wool" },
  { id: 66, manufacturer: "Silk" },
  { id: 67, manufacturer: "Vinyl" },
  { id: 68, manufacturer: "Studioart" },
  { id: 69, manufacturer: "Qurails" },
  { id: 70, manufacturer: "Sunbrella" },
  { id: 71, manufacturer: "Misia Paris" },
  { id: 72, manufacturer: "NOBILIS" },
  { id: 73, manufacturer: "Giardini" },
  { id: 74, manufacturer: "Fischbacher" },
  { id: 75, manufacturer: "Aldeco" },
  { id: 76, manufacturer: "White" },
  { id: 77, manufacturer: "Cream" },
  { id: 78, manufacturer: "Beige" },
  { id: 79, manufacturer: "Grey" },
  { id: 80, manufacturer: "Black" },
  { id: 81, manufacturer: "Brown" },
  { id: 82, manufacturer: "Green" },
  { id: 83, manufacturer: "Olive green" },
  { id: 84, manufacturer: "Blue" },
  { id: 85, manufacturer: "Navy blue" },
  { id: 86, manufacturer: "Sea blue" },
  { id: 87, manufacturer: "Burgundy" },
  { id: 88, manufacturer: "Red" },
  { id: 89, manufacturer: "Pink" },
  { id: 90, manufacturer: "Purple" },
  { id: 91, manufacturer: "Gold" },
  { id: 92, manufacturer: "Bronze" },
  { id: 93, manufacturer: "Silver" }
];
